import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "telegram-svgrepo-com 1" }, [
      _createElementVNode("path", {
        id: "Vector",
        d: "M2.88399 11.0165C2.88399 11.0165 11.0662 7.66872 13.904 6.48997C14.9917 6.01847 18.6809 4.5096 18.6809 4.5096C18.6809 4.5096 20.3835 3.8496 20.2416 5.4526C20.1942 6.11272 19.8159 8.4231 19.4375 10.9221C18.87 14.4585 18.2551 18.3247 18.2551 18.3247C18.2551 18.3247 18.1606 19.4092 17.3566 19.5978C16.5525 19.7865 15.2282 18.9377 14.9917 18.7491C14.8026 18.6076 11.4446 16.4858 10.215 15.4486C9.88386 15.1657 9.50549 14.5998 10.2622 13.9397C11.9649 12.3838 13.9986 10.4506 15.2282 9.22472C15.7957 8.65885 16.3634 7.3386 13.9986 8.94172C10.6406 11.2521 7.32986 13.4211 7.32986 13.4211C7.32986 13.4211 6.57324 13.8926 5.15436 13.4682C3.73549 13.0438 2.08011 12.4781 2.08011 12.4781C2.08011 12.4781 0.945114 11.7707 2.88424 11.0165H2.88399Z",
        stroke: "currentColor",
        "stroke-width": "1.7"
      })
    ], -1)
  ])))
}
export default { render: render }